import React from 'react';

/**
 * 프로젝트 진행 순서 안내 컴포넌트
 * 프로젝트 상세보기 모달에서 사용
 */
const ProjectJourneyBox = () => {
  return (
    <div>
      <div className="project-preview-modal__guide-label">Project Journey</div>
      <h3 className="project-preview-modal__section-title">이 프로젝트는 이렇게 진행됩니다 (How this project works)</h3>
      <div className="project-preview-modal__process-container">
        <div className="project-preview-modal__process-step">
          <div className="project-preview-modal__process-icon">✉️</div>
          <div className="project-preview-modal__process-title">1. 프로젝트 지원 (Apply)</div>
          <div className="project-preview-modal__process-desc">인플루언서가 선정 마감 시까지 프로젝트에 지원합니다. (Influencers apply before the selection deadline.)</div>
        </div>
        <div className="project-preview-modal__process-step">
          <div className="project-preview-modal__process-icon">✅</div>
          <div className="project-preview-modal__process-title">2. 인플루언서 선정 (Selection)</div>
          <div className="project-preview-modal__process-desc">광고주가 콘텐츠 홍보를 맡길 인플루언서를 선정합니다. (The advertiser selects influencers for the campaign.)</div>
        </div>
        <div className="project-preview-modal__process-step">
          <div className="project-preview-modal__process-icon">✍️</div>
          <div className="project-preview-modal__process-title">3. 계약 진행 (Contract)</div>
          <div className="project-preview-modal__process-desc">선정된 인플루언서가 프로젝트 참여 계약에 서명합니다. (Selected influencers sign the participation contract.)</div>
        </div>
        <div className="project-preview-modal__process-step">
          <div className="project-preview-modal__process-icon">📸</div>
          <div className="project-preview-modal__process-title">4. 콘텐츠 업로드 (Upload)</div>
          <div className="project-preview-modal__process-desc">인플루언서가 제품/서비스 리뷰 콘텐츠를 가이드에 맞춰 업로드합니다. (Influencers upload review content following the guide.)</div>
        </div>
        <div className="project-preview-modal__process-step">
          <div className="project-preview-modal__process-icon">💰</div>
          <div className="project-preview-modal__process-title">5. 리워드 지급 (Reward)</div>
          <div className="project-preview-modal__process-desc">광고주가 업로드된 콘텐츠를 확인 후, 승인하면 리워드가 인플루언서에게 지급됩니다. (Rewards are paid once the advertiser approves the content.)</div>
        </div>
      </div>
    </div>
  );
};

export default ProjectJourneyBox;
